import React from 'react';
import {NavLink} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiClock, FiEdit3, FiBarChart2, FiSettings} = FiIcons;

const links = [
  {to: '/', label: 'Log Entry', icon: FiEdit3, end: true},
  {to: '/report', label: 'View Report', icon: FiBarChart2},
  {to: '/settings', label: 'Settings', icon: FiSettings}
];

function Header({config, pageTitle}) {
  return (
    <header className="app-header">
      <div className="header-main">
        <NavLink to="/" className="brand">
          {config.logo_url || config.compact_logo_url ? (
            <picture>
              {config.compact_logo_url && (
                <source
                  media="(max-width: 640px)"
                  srcSet={config.compact_logo_url}
                />
              )}
              <img
                src={config.logo_url || config.compact_logo_url}
                alt={`${config.instance_name} logo`}
              />
            </picture>
          ) : (
            <span className="brand-mark">
              <SafeIcon icon={FiClock} />
            </span>
          )}
          <span>
            <strong>{config.instance_name}</strong>
            <small>{pageTitle}</small>
          </span>
        </NavLink>
      </div>
      <nav className="top-nav" aria-label="Primary navigation">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({isActive}) => (isActive ? 'active' : '')}
          >
            <SafeIcon icon={link.icon} />
            <span>{link.label}</span>
          </NavLink>
        ))}
      </nav>
    </header>
  );
}

export default Header;